<template>
	<div>
		<ValidationObserver ref="formModalValidate">
      <b-row>
        <b-col cols="12" md="4">
          <ValidationProvider name="slot_id" rules="required" v-slot="{valid, errors}">
            <b-form-group :label="$t('slot_id')">
              <b-form-input type="text" v-model="formData.slot_id"
                            :state="errors[0] ? false : null"/>
              <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" md="4">
          <ValidationProvider name="slot_type" rules="required" v-slot="{ valid, errors }">
            <b-form-group :label="$t('slot_type')">
              <slot-type-selectbox v-model="formData.slot_type" :validateError="errors[0]" />
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" md="4">
            <ValidationProvider name="course_id" rules="required" v-slot="{ valid, errors }">
                <b-form-group :label="$t('course')">
                    <course-auto-complete  v-model="formData.course_id"
                                           :state="errors[0] ? false : null"/>
                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                </b-form-group>
            </ValidationProvider>
        </b-col>
        <b-col cols="12" md="4">
          <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
            <b-form-group :label="$t('semester')">
              <semesters-selectbox v-model="formData.semester_id"
                                   :validate-error="errors[0]"></semesters-selectbox>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" md="4">
          <ValidationProvider name="registration_academic_year" rules="" v-slot="{valid, errors}">
            <b-form-group :label="$t('registration_academic_year')">
              <academic-years-selectbox v-model="formData.registration_academic_year"
                                        :validate-error="errors[0]"
              />
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" md="4">
					<ValidationProvider name="program_code" rules="" v-slot="{valid, errors}">
						<b-form-group :label="$t('program')">
							<program-selectbox v-model="formData.program_code"
							                   :faculty_code="formData.faculty_code"
							                   :department_code="formData.department_code"
							                   :validate-error="errors[0]"/>
						</b-form-group>
					</ValidationProvider>
				</b-col>
        <b-col cols="12" md="4">
          <ValidationProvider name="pool_id" rules=""
                              :program-code="formData.program_code"
                              v-slot="{ valid, errors }">
            <b-form-group :label="$t('elective_pools_title')">
              <elective-pool-selectbox v-model="formData.pool_id"
                                       :type="formData.slot_type" :validateError="errors[0]" />
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" md="4">
          <ValidationProvider name="credit" rules="required" v-slot="{ valid, errors }">
            <b-form-group :label="$t('credit')">
              <b-form-input type="number" v-model="formData.credit" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-center mt-2">
        <b-button variant="primary" @click="updateForm" :disabled="formLoading">
          {{ $t('save') }}
        </b-button>
      </div>
		</ValidationObserver>
	</div>
</template>

<script>
// Components
import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import SlotTypeSelectbox from "@/components/interactive-fields/SlotTypeSelectbox.vue";
import ElectivePoolSelectbox from "@/components/interactive-fields/ElectivePoolSelectbox";
import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete"

// Services
import StudentSlotBulkService from "@/services/StudentSlotBulkService";

// Other
import { ValidationProvider, ValidationObserver } from "vee-validate"
import StudentSlotService from "@/services/StudentSlotService";

export default {
	components: {
        ElectivePoolSelectbox,
        SlotTypeSelectbox,
        AcademicYearsSelectbox,
        DepartmentSelectbox,
        FacultySelectbox,
        ProgramSelectbox,
        CourseAutoComplete,

        ValidationProvider,
        ValidationObserver,
	},
	props: {
      selectedIds: {
        type: Array,
      }
	},
	data() {
		return {
			formData: {
                slot_id: null,
                slot_type: null,
                course_id: null,
                credit: null,
                semester: null,
                pool_id: null,
                operation_type: 'update',
			},
			formLoading: false,
		}
	},
	watch: {
		formId: function (val) {
			this.get(val)
		}
	},
	async created() {
		// await this.get(this.formId)
	},
	methods: {
		// get(id) {
		// 	StudentSlotService.get(id)
		// 		.then(response => {
		// 			let data = response.data.data;
		// 			this.formData = {
		// 				faculty_code: data.faculty_code,
		// 				department_code: data.department_code,
		// 				program_code: data.program_code,
		// 				registration_academic_year: data.registration_academic_year,
		// 				student_number: data.student_number,
		// 				slot_id: data.slot_id,
		// 				slot_type: data.slot_type,
		// 				course_code: data.course_code,
		// 				semester: data.semester,
		// 			}

		// 		})
		// 		.catch(e => {
		// 			this.showErrors(e)
		// 		})
		// },

      async updateForm() {
          if (this.checkPermission('studentslot_bulkupdate')) {
              const isValid = await this.$refs.formModalValidate.validate();
              if (isValid && this.selectedIds?.length > 0) {
                  this.formLoading = true;

                  const payload = {
                      student_slot_id: this.selectedIds,
                      ...this.formData,
                  };

                  StudentSlotBulkService.update(payload)
                      .then(response => {
                          this.$emit('updateFormSuccess', true);
                          this.$toast.success(this.$t('api.' + response.data.message));
                      })
                      .catch(e => {
                          this.showErrors(e, this.$refs.formModalValidate);
                      })
                      .finally(() => {
                          this.formLoading = false;
                      });
              }
          } else {
              this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'));
          }
      }
	}
}
</script>
